import { createForm } from '../../../factories'

export default createForm(['email', 'name', 'password', 'token'])



// WEBPACK FOOTER //
// ./src/store/modules/register/forms/finishRegistration.js